import React, { useRef } from 'react';
import Slider, { Settings } from 'react-slick';
import 'slick-carousel/slick/slick.css';
import style from './block.module.scss';
import NewsCard from '../news-card';
import { ReactComponent as Arrow } from '../../assets/arrow_right.svg';
import { BlockWrapper, defineBlock, smartProps, useInspectorControl } from '@smartfire/js-block-engine';
import { EditableText } from '@smartfire/components';
const InspectorLazy = React.lazy(() => import('./Inspector'));

function Block({ readNext, news }) {
    useInspectorControl(InspectorLazy, []);

    const sliderRef = useRef<Slider>();
    const sliderSettings: Settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        autoplay: false,
        slidesToShow: Math.min(3, news ? news.length : 0),
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: parseInt(style.tabletBreakpoint.replace('px', '')),
                settings: {
                    slidesToShow: Math.min(2, news ? news.length : 0),
                },
            },
            {
                breakpoint: parseInt(style.mobileBreakpoint.replace('px', '')),
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.content}>
                <div className={style.top}>
                    <EditableText className={style.title} smartProp="title" tagName="h2" />
                    <div className={style.controlBox}>
                        <div
                            className={style.previous}
                            onClick={() => {
                                sliderRef.current!.slickPrev();
                            }}
                        >
                            <Arrow />
                        </div>
                        <div
                            className={style.next}
                            onClick={() => {
                                sliderRef.current!.slickNext();
                            }}
                        >
                            <Arrow />
                        </div>
                    </div>
                </div>
                <div className={style.newsSlider}>
                    {/*@ts-ignore ref is allowed */}
                    <Slider ref={sliderRef} className={style.slider} {...sliderSettings}>
                        {news &&
                            news.map((news, index) => (
                                <div key={`news-${index}`}>
                                    <NewsCard
                                        className={style.card}
                                        imageMobile={news.mobileThumbnail}
                                        image={news.thumbnail}
                                        link={news.guid}
                                        linkText={readNext}
                                        resume={news.post_excerpt}
                                        tags={news.tags}
                                        title={news.post_title}
                                    />
                                </div>
                            ))}
                    </Slider>
                </div>
            </div>
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block: Block as React.FC<unknown>,
    smartProps: {
        title: smartProps.string.withDefault("L'actualité guédelon"),
        readNext: smartProps.string.withDefault("Lire l'article"),
    },
    setup: {
        title: 'Home Actualités',
    },
});
